import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { LoadingBackDrop } from "../../../components/loader";
import { theme } from "../../../helpers/theme";
import { GoBackButton } from "../../../components/GoBackButton";
import { pricelistGetAllById } from "../../../services/pricelists/pricelist-get-by-id";
import { PriceList } from "../../../services/pricelists/pricelist-get-by-id/types";
import PricelistAddForm from "./PricelistAddForm";


// interface TabPanelProps {
//   children?: React.ReactNode;
//   index: number;
//   value: number;
// }

// function TabPanel(props: TabPanelProps) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       className="tabPanel"
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {children}
//     </div>
//   );
// }


export const OperatorWarehousesPricelistAdd = () => {
  const { id } = useParams();

  // const [value, setValue] = useState(0);

  // const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  //   setValue(newValue);
  // };

  // if (GetPricelistGetAllById.isLoading || GetPricelistGetAllById.isRefetching) {
  //   return <LoadingBackDrop loading={true} />;
  // }
  return (
    <>
    <ButtonWrapper>
    <GoBackButton description={"Powrót"} goToUrl={-1} />
    </ButtonWrapper>
    <FormWrapper>
      {/* <ButtonWrapper> */}
        {/* <Tabs 
          sx={{
            width: "70%",
          }} 
          centered
          value={value} onChange={handleChange} 
          aria-label="basic tabs example"
        >
          <Tab label="Dane Podstawowe"  />
          <Tab label="Adres"  />
        </Tabs> */}
      {/* </ButtonWrapper> */}

      {/* <TabPanel value={value} index={0}> */}
        <PricelistAddForm />
      {/* </TabPanel> */}
    </FormWrapper>
    </>
  );
};

export default OperatorWarehousesPricelistAdd;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0px;
  // padding: 20px;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
    width: 70%;
    margin-top: 0px;
  }

  .tabPanel {
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  z-index: 10000;
  // display: flex;
  // justify-content: flex-start;


  @media (${theme.device.laptop}) {
    margin-left: 320px
  }
`;